import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ApiManager from './plugins/ApiManager'
import './assets/tailwind.css'

createApp(App).use(router).use(ApiManager).mount('#app')
